import { get } from '@/utils/https'
import type { ComplianceAuditResult } from '@/utils/complianceAudit/types'

export async function fetchComplianceAudit(month?: string, teamId?: string | null) {
  const params: Record<string, string> = {}
  if (month) {
    params.month = month
  }
  if (teamId) {
    params.team_id = teamId
  }

  return get('/api/app/v1/compliance/audit', params) as Promise<{
    code: number
    message: string
    data?: ComplianceAuditResult
  }>
}
